/**
 * GraphQL query strings for enrollment multi home
 * Extracted for use in E2E environments without Apollo Client dependencies
 */

export const getEnrollmentMultiHomeDataQuery = `
  mutation getEnrollmentMultiHomeData($submitEnrollmentInput: SubmitEnrollmentInput!) {
    submitEnrollment(submitEnrollmentInput: $submitEnrollmentInput) {
      ... on SubmitEnrollmentSuccess {
        __typename
        path
      }
      ... on SubmitEnrollmentError {
        __typename
        path
        type
      }
    }
  }`
